export default __webpack_public_path__ + "static/dataHubLogo-f97a934c7765450bfa10b0dc9b7c43e4.svg";